import * as React from 'react'

export const IconNotes = () => (
  <svg width='24' height='24' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <rect x='2' y='5' width='16' height='10' rx='3' fill='#EEE6EF' />
    <rect x='6' y='9' width='16' height='10' rx='3' fill='currentColor' />
    <circle cx='14' cy='14' r='2' fill='#EEE6EF' />
    <circle cx='9' cy='14' r='1' fill='#EEE6EF' />
    <circle cx='19' cy='14' r='1' fill='#EEE6EF' />
  </svg>
)
